import * as React from 'react';
import { styled } from '@mui/material/styles';
import {Box} from '@mui/material';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CountUp from 'react-countup';
import Divider from '@mui/material/Divider';

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme }) => ({
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
  variants: [
    {
      props: ({ expand }) => !expand,
      style: {
        transform: 'rotate(0deg)',
      },
    },
    {
      props: ({ expand }) => !!expand,
      style: {
        transform: 'rotate(180deg)',
      },
    },
  ],
}));

export default function FigureCard({title, figure, color, icon:Icon }) {
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Card sx={{ 
      maxWidth: 163, 
      minWidth: 163
    }}>
      <CardHeader sx={{
        p:1,
        alignItems: 'flex',
        '& .MuiCardHeader-title': {
          fontSize: 12,
          fontWeight: 500,
          lineHeight: 1.1,
          // whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }
      }}
        avatar={
          <Avatar sx={{ bgcolor: color }} aria-label="recipe">
            {Icon && <Icon style={{ fill: 'white', width: 32, height: 32 }} />}
          </Avatar>
        }

        title={title}

      />
      <Divider sx={{ mx: 1, my: 0, borderColor: 'divider' }} />
      <CardContent sx={{
          p:1,
         '&:last-child': {
            pb: 1               // override MUI’s default last-child padding
          }
        }}
      >
        <Typography variant="h5" align='right' sx={{ color: 'text.secondary' }}>
          <CountUp
            // start={1}
            end={figure}
            duration={1.2}
            separator=","
          />
          {/* {figure} */}
        </Typography>
      </CardContent>
     
    </Card>
  );
}